import { baseQuery } from "./baseQuery";
import { createApi } from "@reduxjs/toolkit/query/react";

export const partnerWhitelabelConfigService = createApi({
  reducerPath: "partnerWhitelabelConfigService",
  baseQuery: baseQuery,
  endpoints: (builder) => ({
    getPartnerWhitelabelConfig: builder.query<any, void>({
      query: () => ({
        url: `/partner-whitelabel-config`,
        method: "GET",
      }),
    }),
    createPartnerWhitelabelConfig: builder.mutation<any, any>({
      query: (params) => ({
        url: `/partner-whitelabel-config/${params?.partner_id}`,
        body: params,
        method: "POST",
        headers: {
          PageName: "Partner Whitelabel Config Service",
        },
      }),
    }),
    updatePartnerWhitelabelConfig: builder.mutation<any, any>({
      query: (params) => ({
        url: `/partner-whitelabel-config/${params?.partner_id}/config/${params?.id}`,
        body: params,
        method: "PUT",
        headers: {
          PageName: "Partner Whitelabel Config Service",
        },
      }),
    }),
    deletePartnerWhitelabelConfig: builder.mutation<any, { partnerId: number }>({
      query: (params) => ({
        url: `/partner-whitelabel-config/${params?.partnerId}`,
        params,
        method: "DELETE",
        headers: {
          PageName: "Partner Whitelabel Config Service",
        },
      }),
    }),
    getMerchantWhitelabelConfig: builder.query<any, { merchantId: number }>({
      query: (params) => ({
        url: `/merchant-whitelabel-config/${params?.merchantId}`,
        method: "GET",
        headers: {
          PageName: "Merchant Whitelabel Config",
        },
      }),
    }),
    createMerchantWhitelabelConfig: builder.mutation<any, any>({
      query: (params) => ({
        url: `/merchant-whitelabel-config/${params?.merchant_id}`,
        body: params,
        method: "POST",
        headers: {
          PageName: "Merchant Whitelabel Config",
        },
      }),
    }),
  }),
});

export const {
  useGetPartnerWhitelabelConfigQuery,
  useCreatePartnerWhitelabelConfigMutation,
  useUpdatePartnerWhitelabelConfigMutation,
  useDeletePartnerWhitelabelConfigMutation,
  useGetMerchantWhitelabelConfigQuery,
  useLazyGetMerchantWhitelabelConfigQuery,
  useCreateMerchantWhitelabelConfigMutation,
} = partnerWhitelabelConfigService;
